import type { MaturityItemId } from '@cobliteam/hooks/src/useBasicValueMaturity/basicValueMaturityModel';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface BasicValueGuideState {
  /** Item the guided modal was manually opened at (from the Basic Value page), or null. */
  openItemId: MaturityItemId | null;
  /** Open the guided modal focused on a specific item. */
  openAt: (itemId: MaturityItemId) => void;
  /** Close the manually-opened guide. */
  close: () => void;
}

/**
 * App-wide control to open the Basic Value guided modal imperatively at a given step. The modal is
 * manual-only (no auto-popup): it opens from the "Primeiros passos" page's "Configurar" buttons and
 * from the home maturity hero CTA (which navigates to /basic-value?guide=open). This store is the
 * single entry point that drives it.
 */
const useBasicValueGuideStore = create<BasicValueGuideState, [['zustand/devtools', never]]>(
  devtools(
    (set) => ({
      openItemId: null,
      openAt: (itemId) => set({ openItemId: itemId }, false, 'basicValueGuide/openAt'),
      close: () => set({ openItemId: null }, false, 'basicValueGuide/close'),
    }),
    { name: 'useBasicValueGuideStore' }
  )
);

export default useBasicValueGuideStore;
